import {FC} from 'react'
import {FormRetiredGuests} from '../forms/FormRetiredGuests'

const HeaderRetiredGuestsPanel: FC = () => {
  return <FormRetiredGuests />
}

export {HeaderRetiredGuestsPanel}
